module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-01-fb6ba357a151b4e5dc849d0870d1c2a1.jpg";